<template>
  <div class="stations">
    <div :class="['mobile-top-station-layer', 'mobile-show', mobileSwitcherClass]" :style="{'--mobile-switcher-height': mobileSwitcherHeight}">
      <SettingsTop :initialShowCondition="mobileSwitcher.state == 'closed'" @click="toggleMobileSwitcher"></SettingsTop>
      <SettingsBottom :initialShowCondition="mobileSwitcher.state == 'open'" @setNowViewing="setNowViewing"></SettingsBottom>
    </div>
    <div class="station-layer" id="station-layer-1" :style="{'--left-size': layer1.leftSize + '%', '--middle-size': layer1.middleSize + '%', '--right-size': layer1.rightSize + '%'}">
      <div class="station-container station-container--is-left">
        <Station which="left" :sizeState="left.sizeState" :behind="left.behind" :anchored="left.anchored" :hasLeftSpacer="false" ref="leftStation">
          <template #top-content>
            <div class="add__top-content">
              <button @click="toggleLeftStation" class="add-block">{{ changeSizeLabel }}</button>
            </div>
          </template>
          <template #main-content>
            <Uploader></Uploader>
            <!-- Itssss alllll an illuuusssiioooooooooonnnNNNNNNNNNNNNNNNN -->
          </template>
        </Station>
      </div>

      <div class="station-container station-container--is-middle station-container--is-empty"></div>

      <div class="station-container station-container--is-right">
        <div class="station-stack mobile-hide">
          <Station which="right1" id="right1Station" :sizeState="right1.sizeState" :verticalSizeState="right1.verticalSize" :behind="right1.behind" :anchored="right1.anchored" :hasLeftSpacer="false" ref="right1Station" :fitHeight="true">
            <template #top-content>
              <SettingsTop :initialShowCondition="right2.verticalSize == 'fit'" @click="toggleRightStack"></SettingsTop>
            </template>
            <template #main-content>
              <SettingsBottom :initialShowCondition="right2.verticalSize == 'shrink'" @setNowViewing="setNowViewing"></SettingsBottom>
            </template>
          </Station>
          <Station which="right2" id="right2Station" :sizeState="right2.sizeState" :shouldShow="shouldShowRight2" :verticalSizeState="right2.verticalSize" :behind="right2.behind" :anchored="right2.anchored" :hasLeftSpacer="false" :hasTopSpacer="true" :hasDynamicHeight="true" ref="right2Station">
            <template #top-content>
            </template>
            <template #main-content>
              <transition name="switchView" mode="out-in">
                <ConceptsNav v-if="homeView == 'Carousel'"></ConceptsNav>
                <!-- <StreamNav v-else-if="homeView == 'Stream'"></StreamView> -->
              </transition>
            </template>
          </Station>
        </div>
      </div>

    </div>

    <div class="station-layer" id="station-layer-2" :style="{'--left-size': layer2.leftSize + '%', '--middle-size': layer2.middleSize + '%', '--right-size': layer2.rightSize + '%'}">
      <div :class="['station-container', 'station-container--is-left', 'station-container--is-empty', layer2NoMargin]"></div>

      <div :class="['station-container', 'station-container--is-middle', main.sizeState]">
        <Station which="main" :sizeState="main.sizeState" :behind="main.behind" :anchored="main.anchored" :hasLeftSpacer="true" :hasRightSpacer="true" ref="mainStation">
          <template #top-content>
            <div class="mainStation__top-content">
              <transition name="switchView" mode="out-in">
                <div class="view-switcher" v-if="nowViewing == 'Concepts' && !noGroupAvailable">
                  <div :class="['view-select', isUsingView[0], 'mobile-hide']" @click="setView('Carousel')">Concepts</div>
                  <div :class="['view-select', isUsingView[1], 'mobile-show']" @click="setView('List')">Concepts</div>
                  <div :class="['view-select', isUsingView[2]]" @click="setView('Stream')">Stream</div>
                  <div v-if="$store.state.walletConnect.user.role == 'Admin'" :class="['view-select', isUsingView[3]]" @click="setView('Team')">Admin</div>
                  <div v-if="$store.state.org.activeTrust == 'autumn'" :class="['view-select', isUsingView[4]]" @click="setView('Manual')">Guide</div>
                  <!-- <div :class="['view-select', isUsingView[2]]" @click="setView('TimeMachine')">Time Machine</div> -->
                </div>
              </transition>
              <transition name="switchView" mode="out-in">
                <button v-if="nowViewing == 'Concept'" @click="headHome" class="shadow">Home</button>
                <button v-else-if="nowViewing == 'Index'" @click="backNowViewing" class="shadow">Back</button>
              </transition>
            </div>
          </template>
          <template #main-content>
            <transition name="switchView" mode="out-in">
              <keep-alive exclude="ConceptExpanded">
                <ConceptStream v-if="nowViewing == 'Concepts' && homeView == 'Carousel'" :showGroupError="noGroupAvailable"></ConceptStream>
                <ConceptExpanded v-else-if="nowViewing == 'Concept'" :conceptSlug="$store.state.routing.expandedConcept" @headHome="headHome"></ConceptExpanded>
                <Stream v-else-if="nowViewing == 'Concepts' && homeView == 'Stream'"></Stream>
                <Team v-else-if="nowViewing == 'Concepts' && homeView == 'Team'"></Team>
                <LrftManual v-else-if="nowViewing == 'Concepts' && homeView == 'Manual'"></LrftManual>
                <ConceptList v-else-if="nowViewing == 'Concepts' && homeView == 'List'" :showGroupError="noGroupAvailable"></ConceptList>
                <Index v-else-if="nowViewing == 'Index'"></Index>
              </keep-alive>
            </transition>
          </template>
        </Station>
      </div>

      <div class="station-container station-container--is-right station-container--is-empty"></div>
    </div>
  </div>
</template>

<script>
import ConceptStream from '@trust/components/ConceptStream.vue'
import ConceptList from '@trust/components/ConceptList.vue'
import Station from '@trust/components/Station.vue'
import ConceptsNav from '@trust/components/ConceptsNav.vue'
import ConceptExpanded from '@trust/components/views/ConceptExpanded.vue'
import Uploader from '@trust/components/Uploader.vue';
import Stream from '@trust/components/Stream.vue'
import SettingsTop from '@trust/components/SettingsTop.vue'
import SettingsBottom from '@trust/components/SettingsBottom.vue'
import Index from '@trust/components/views/Index.vue'
import Team from '@trust/components/Team.vue'
import LrftManual from '@trust/components/LrftManual.vue'


const totalSize = 9;
const noSize = 0 / totalSize * 100;
const smallSize = 2 / totalSize * 100;
// const smediumSize = 3 / totalSize * 100;
const mediumSize = 5 / totalSize * 100;
const largeSize = 7 / totalSize * 100;
const fullSize = 9 / totalSize * 100;

// 0 7 2
const sitLeftLayer = {
  leftSize: noSize,
  middleSize: largeSize,
  rightSize: smallSize
}

// 2 5 2
const sitMiddleLayer = {
  leftSize: smallSize,
  middleSize: mediumSize,
  rightSize: smallSize
}

// 2 7 0
const sitRightLayer = {
  leftSize: smallSize,
  middleSize: largeSize,
  rightSize: noSize
}

// 0 9 0
const sitFullLayer = {
  leftSize: noSize,
  middleSize: fullSize,
  rightSize: noSize
}

// 9 0 0
const sitNoLayer = {
  leftSize: fullSize,
  middleSize: noSize,
  rightSize: noSize
}


export default {
  name: 'Stations',
  components: {
    ConceptStream,
    Station,
    ConceptsNav,
    ConceptExpanded,
    Uploader,
    Stream,
    ConceptList,
    SettingsTop,
    SettingsBottom,
    Index,
    Team,
    LrftManual
  },
  data() {
    return {
      nowViewing: 'Concepts',
      previousNowViewing: null,
      homeView: 'Carousel', // or 'Stream', etc.
      changeSizeLabel: 'Add',
      noGroupAvailable: false,
      left: {
        sizeState: 'small',
        behind: true,
        anchored: 'left',
      },
      main: {
        sizeState: 'sitLeft',
        behind: false,
        anchored: 'right',
      },
      right1: {
        sizeState: 'small',
        behind: true,
        anchored: 'top',
        verticalSize: 'fit',
      },
      right2: {
        sizeState: 'small',
        behind: false,
        anchored: 'bottom',
        verticalSize: 'fit',
      },
      layer1: {
        leftSize: smallSize,
        middleSize: mediumSize,
        rightSize: smallSize,
      },
      layer2: {
        leftSize: noSize,
        middleSize: largeSize,
        rightSize: smallSize,
      },
      mobileSwitcher: {
        state: 'closed',
      }
    }
  },
  computed: {
    layer2NoMargin(){
      if(this.layer2.leftSize == 0){
        return 'station-container--no-margin';
      } else {
        return '';
      }
    },
    shouldShowRight2(){
      if(this.nowViewing == 'Concept' || this.nowViewing == 'Index'){
        return false;
      } else {
        return true;
      }
    },
    isUsingView(){
      let views = ['Carousel', 'List', 'Stream', 'Team', 'Manual'] // 'time-machine'
      let arr = [];
      for(let i = 0; i < views.length; i++){
        if(this.homeView == views[i]) {
          arr.push('selected')
        } else {
          arr.push('')
        }
      }

      return arr;
    },
    isMobile(){
      if(window.innerWidth <= 600){
        return true;
      } else {
        return false;
      }
    },
    mobileSwitcherClass(){
      return this.mobileSwitcher.state == 'open' ? 'switcher--is-open' : '';
    },
  },
  mounted() {
    this.$store.commit('fetchConcepts')
    this.$store.commit('fetchBlocks')
    this.$store.dispatch('fetchUserTrusts')
    this.$store.dispatch('fetchTrustMeta')
    this.$store.dispatch('fetchUser')

    if(this.$store.state.routing.expandedConcept != null) {
      this.$store.dispatch('closeRight');
      this.updateViewingState();
    }

    if(this.isMobile){
      this.setView('List');
      this.updateGrid();
    }

    this.checkForGroupInUrl();
  },
  methods: {
    toggleLeftStation() {
      if(this.$store.state.stations.grid.leftOpen == false){
        this.$store.commit('openNewBlock');
      } else {
        this.$store.commit('closeNewBlock', {reason: 'cancel'});
      }
      this.$store.dispatch('toggleLeft');
    },
    updateRightContentHeight(){
      let totalHeight = document.querySelector('#right1Station').getBoundingClientRect().height;
      let heightTop = document.querySelector('#right1Station .station__top').getBoundingClientRect().height;
      let heightMain = document.querySelector('#right1Station .station__main').getBoundingClientRect().height;
      let height = totalHeight - (heightTop + heightMain) + 44 - 10;
      this.$store.commit('setRightContentHeight', { height });
    },
    toggleRightStack() {
      this.updateRightContentHeight();

      if(this.right2.verticalSize == 'fit'){
        this.right2.verticalSize = 'shrink';
        if(this.nowViewing == 'Concept' || this.nowViewing == 'Index'){
          this.$store.dispatch('openRight');
        }

      } else {
        this.right2.verticalSize = 'fit';
        if(this.nowViewing == 'Concept' || this.nowViewing == 'Index'){
          this.$store.dispatch('closeRight');
        }

      }
    },
    closeRightStack(){
      this.right2.verticalSize = 'fit';
    },
    updateViewingState(){
      let to = this.$store.state.routing.expandedConcept;
      if(to == null) {
        this.nowViewing = 'Concepts';
      } else {
        this.nowViewing = 'Concept';
      }
    },
    updateGrid(){
      let openLeft = this.$store.state.stations.grid.leftOpen;
      let openRight = this.$store.state.stations.grid.rightOpen;

      let sitLeft = !openLeft && openRight;
      let sitMiddle = openLeft && openRight;
      let sitRight = openLeft && !openRight;
      let sitFull = !openLeft && !openRight;

      if(this.isMobile){
        this.layer1.leftSize = fullSize;
        this.layer1.middleSize = noSize;
        this.layer1.rightSize = noSize;
      }

      if(sitLeft) {
        this.main.sizeState = 'sitLeft'; // used to be medium
        this.changeSizeLabel = 'Add'; // TODO: Move this label change elsewhere
        this.layer2 = sitLeftLayer;
        if(this.isMobile){
          this.layer2 = sitFullLayer;
        }

      } else if (sitMiddle){
        this.main.sizeState = 'sitMiddle';
        this.changeSizeLabel = 'Cancel';
        this.layer2 = sitMiddleLayer;
        if(this.isMobile){
          this.main.sizeState = 'sitNone';
          this.layer2 = sitNoLayer;
        }

      } else if (sitRight) {
        this.main.sizeState = 'sitRight';
        this.changeSizeLabel = 'Cancel';
        this.layer2 = sitRightLayer;
        if(this.isMobile){
          this.main.sizeState = 'sitNone';
          this.layer2 = sitNoLayer;
        }

      } else if (sitFull) {
        this.main.sizeState = 'sitFull';
        this.changeSizeLabel = 'Add';
        this.layer2 = sitFullLayer;
        this.closeRightStack(); // So that future rightStack toggles work
        if(this.isMobile){
          this.main.sizeState = 'sitLeft'; // So that it doesn't try to expand right
        }
      }


    },
    headHome(){
      this.$store.dispatch('routing/goToGroupHome', {});
      this.$store.dispatch('openRight');
      this.$store.dispatch('closeLeft');
    },
    setView(view){
      this.homeView = view;
    },
    setNowViewing(view){
      if(view == 'Index'){
        this.$store.dispatch('closeRight');
        this.mobileSwitcher.state = 'closed';
      }
      this.previousNowViewing = this.nowViewing;
      this.nowViewing = view;
    },
    backNowViewing(){
      this.nowViewing = this.previousNowViewing;
      this.previousNowViewing = null;
      if(this.nowViewing == 'Concept'){
        this.$store.dispatch('closeRight');
      } else {
        this.$store.dispatch('openRight');
      }
    },
    // openNewBlock(){
    //   this.$store.commit('openNewBlock')
    // },
    toggleMobileSwitcher(){
      if(this.mobileSwitcher.state == 'open'){
        this.mobileSwitcher.state = 'closed';
      } else {
        this.mobileSwitcher.state = 'open';
      }
    },
    checkForGroupInUrl(){
      if(window.location.pathname == '/'){
        console.log('no group available')
        this.noGroupAvailable = true;
      }
    }
  },
  watch: {
    '$store.state.routing.expandedConcept' () {
      this.updateViewingState();
      this.updateGrid();
    },
    '$store.state.stations.grid.leftOpen' () {
      this.updateGrid();
    },
    '$store.state.stations.grid.rightOpen' () {
      this.updateGrid();
    },
    '$store.state.org.userTrusts'(){
      // Update the height of the right panel if list of trusts
      // finished loading while we have it open
      if(this.$store.state.stations.grid.rightOpen){
        requestAnimationFrame(() => {
          this.updateRightContentHeight();
          this.$refs.right2Station.updateDynamicHeight();
        });
      }
    },
    '$store.state.org.activeTrust'(){
      this.$store.dispatch('fetchTrustMeta')
      this.$store.dispatch('fetchUser')
    }
  }
}

</script>

<style>

.stations {
  height: 100vh;
  width: 100vw;
  padding: var(--station-gap);
  box-sizing: border-box;
  background: var(--beige-400);
  position: relative;
}

.station-layer {
  position: absolute;
  width: calc(100vw - var(--station-gap) * 2);
  height: calc(100vh - var(--station-gap) * 2);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  pointer-events: none;
}

.station-layer-mobile-top {
  position: absolute;
}

.station-stack {
  position: relative;
  height: 100%;
  width: 100%;
}

.station-stack .station__wrapper {
  position: absolute;
}

.station-container {
  pointer-events: none;
  transition: var(--transition-base);
}

.station-container--is-left {
  width: var(--left-size);
  margin-right: var(--station-gap);
}

.station-container--is-middle {
  width: var(--middle-size);
  margin-right: var(--station-gap);
}

.station-container--is-middle.sitFull,
.station-container--is-middle.sitRight {
  margin-right: 0;
}

.station-container--is-right {
  width: var(--right-size);
}

.station-container--is-empty {
  pointer-events: none;
}

.station-container--no-margin {
  margin: 0;
}

.switchView-enter-active,
.switchView-leave-active {
  transition: var(--transition-base);
}

.switchView-enter-from,
.switchView-leave-active {
  opacity: 0;
}

.fadeQuick-enter-active,
.fadeQuick-leave-active {
  transition: var(--transition-snappy);
}

.fadeQuick-enter-from,
.fadeQuick-leave-active {
  opacity: 0;
}


.settings__top-content {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 24px;
  font-size: 15px;
  line-height: 150%;
  cursor: pointer;
}

.settings__top-content p {
  margin: 0;
}

.walletInitial {
  font-family: "Untitled Serif";
  font-weight: 500;
  font-style: italic;
  font-style: italic;
  text-align: center;
  color: var(--beige-1000);
  word-break: break-all;
}

.walletInitial.uppercase {
  text-transform: uppercase;
}

.settings__bottom-content {
  width: 100%;
  padding: 0px 0px 10px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.trust-list {
  width: 100%;
  font-family: "Untitled Serif";
  font-weight: 400;
  color: var(--beige-700);
  max-height: 70vh;
  overflow-y: scroll;
}

.trust-list .trust-link {
  color: var(--beige-700);
  width: 100%;
  padding-bottom: 8px;
  transition: all 200ms ease-in-out;
  text-decoration: none;
}

.trust-list .trust-link:hover {
  cursor: pointer;
  color: var(--beige-1000);
}

.trust-list .trust-link p {
  margin: 0;
  padding: 4px 15px 4px 0px;
  width: 100%;
  border-bottom: 1px solid var(--beige-600);
  box-sizing: border-box;
}

.wallet-details {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
  padding-right: 15px;
  box-sizing: border-box;
}

.wallet-details__name {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.wallet-details button {
  width: 100%;
  margin-top: 10px;
}

.add__top-content {
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mainStation__top-content {
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.view-switcher {
  display: flex;
  padding: 0px;
  width: 100%;
  box-sizing: border-box;
  font-family: Lettera;
  font-weight: 400;
  font-size: 13px;
  height: 100%;
  align-items: center;
}

.view-switcher .view-select {
  cursor: pointer;
  margin-right: 15px;
  color: var(--beige-700);
}

.view-switcher .view-select.selected,
.view-switcher .view-select:hover {
  color: var(--black-900);
}

.mobile-top-station-layer {
  height: var(--mobile-top-height);
  transition: var(--transition-base);
  overflow: hidden;
  border: var(--border-station);
  background: var(--beige-300);
  margin-bottom: 10px;
  box-sizing: border-box;
}

.mobile-top-station-layer.switcher--is-open {
  height: var(--mobile-top-full-height);
  margin-bottom: 40px;
  border-radius: var(--mobile-border-radiuses);
}

/* Mobile Styling */
@media (max-device-width: 600px) {
  #station-layer-1 .station-container--is-left,
  #station-layer-1 .station-container--is-middle,
  #station-layer-2 .station-container--is-middle {
    margin-right: 0;
  }

  .station-layer {
    height: fit-content;
  }

  .station-container {
    height: fit-content;
  }
}

@media screen and (max-device-width: 600px) and (orientation:landscape) {

}

</style>
